import { Nullable } from 'global';
import { CreditLineRequest, CreditLineStatusEnum } from '@trnsact/trnsact-shared-types';
import { CreditLineFormValues } from '../model';

export function getCreditLineFormDefaultValues(
  creditLineRequest: Nullable<CreditLineRequest> | undefined
): CreditLineFormValues {
  return {
    notes: '',
    approvedBy: null,
    approvedOn: null,
    allNotes: creditLineRequest?.notes || '',
    requestedAmount: creditLineRequest?.requestedAmount || 0,
    approvedAmount: creditLineRequest?.approvedAmount || null,
    lenderProfileId: creditLineRequest?.lenderProfileId || null,
    status: creditLineRequest?.status || CreditLineStatusEnum.New,
    expirationDate: creditLineRequest?.expirationDate ? new Date(creditLineRequest.expirationDate) : null,
  };
}
